<template>
    <div>
        <order-search
                :count-data="countTagData"
                :search-url="searchUrl"
                :handle-success="initOrderRes"
                :refresh-url="defaultUrl"
                :handle-re-fresh="initOrderRes">

            <el-col :span="2">
                <el-tag type="info" size="small">订单数量:{{ ordersLength }} / {{ count }}</el-tag>
            </el-col>
            <el-col :span="1">
                <i v-show="loading" class="el-icon-loading"></i>
            </el-col>
        </order-search>

        <order-table
                ref="inStoreOrder"
                :orders="orders"
                :show-modify="true"
                :click-modify="clickModify"
                :items="orderTableItems"/>

        <next-foo :next-url="nextUrl" :handle-response="handleNext" :no-more="noMore"/>

        <el-dialog
                :title="`${currentOrder.the_id} 的入库信息`"
                :visible.sync="modifyDialogShow"
                width="60%"
                :show-close="true"
                :lock-scroll="false"
                :before-close="handleClose">
            <template>

                <!-- 新增入库批次  -->
                <el-dialog
                        width="40%"
                        title="新增入库批次"
                        :visible.sync="addInStoreRecordDialog"
                        append-to-body>
                    <template>
                        <el-table :summary-method="addInStoreSummaries" show-summary
                                  :data="addInStoreRecordData.sizeinstore_set">
                            <el-table-column prop="shop_id" width="140" label="尺码"/>
                            <el-table-column prop="color" label="颜色"/>
                            <el-table-column prop="planNum" label="入库通知"/>
                            <el-table-column prop="FinishNum" label="已入库"/>
                            <el-table-column width="140" align="center" label="此次入库">
                                <template slot-scope="scope">
                                    <el-input-number
                                            size="mini"
                                            :min="0"
                                            :max="scope.row.maxNum"
                                            :step="1"
                                            v-model="scope.row.num">
                                    </el-input-number>
                                </template>
                            </el-table-column>
                        </el-table>
                    </template>
                    <span slot="footer" class="dialog-footer">
                        <el-button size="mini" @click="createInStoreRecord" :loading="createInStoreRecordLoading"
                                   type="primary">确 认</el-button>
                        <el-button size="mini" @click="addInStoreRecordDialog=false">关 闭</el-button>
                    </span>
                </el-dialog>

                <!--                 展示入库批次  -->
                <el-dialog
                        width="40%"
                        :title="currentInStoreRecord.title"
                        :visible.sync="inStoreRecordDialog"
                        append-to-body>
                    <el-table :data="currentInStoreRecord.sizeinstore_set">
                        <el-table-column prop="_shop_id" label="尺码"/>
                        <el-table-column prop="_maxNum" label="通知数量"/>
                        <el-table-column label="入库数量">
                            <template slot-scope="scope">
                                <el-input-number
                                        size="mini"
                                        :min="0"
                                        :max="scope.row._maxNum"
                                        :step="1"
                                        v-model="scope.row.num">
                                </el-input-number>
                            </template>
                        </el-table-column>
                    </el-table>
                    <span slot="footer" class="dialog-footer">
                        <el-button size="mini"
                                   :loading="updateCurInStoreRecordLoading"
                                   @click="updateCurrentInStoreRecord"
                                   :disabled="!canModify"
                                   type="primary">更 新</el-button>
                        <el-button size="mini"
                                   @click="deleteCurrentInStoreRecord"
                                   :loading="deleteCurInStoreRecordLoading"
                                   :disabled="!canModify"
                                   type="danger">删 除</el-button>
                        <el-button size="mini" @click="inStoreRecordDialog=false">关 闭</el-button>
                    </span>
                </el-dialog>

                <el-table
                        show-summary
                        :summary-method="inStoreSummaries"
                        :data="currentOrder.ordersize_set">
                    <el-table-column prop="size.shop_id" label="尺码"/>
                    <el-table-column prop="color" label="颜色"/>
                    <el-table-column prop="in_storage_amount" label="入库通知"/>
                    <el-table-column prop="finish_in_storage" label="已入库"/>
                    <template v-for="(inStoreRecord,index) in inStoreRecords">
                        <el-table-column>
                            <template slot="header" slot-scope="scope">
                                <el-popover
                                        placement="top-start"
                                        width="200"
                                        trigger="hover">
                                    <p>{{ `入库时间:${inStoreRecord.created}` }}</p>
                                    <el-button slot="reference" @click="showCurrentInStoreRecord(inStoreRecord,index+1)"
                                               size="mini">
                                        批次{{ index+1 }}
                                    </el-button>
                                </el-popover>

                            </template>

                            <template slot-scope="scope">
                                <span>{{ getSizeInStoreNum(scope.row.sizeinstore_set,inStoreRecord) }}</span>
                            </template>
                        </el-table-column>
                    </template>


                </el-table>
                <el-row style="margin: 10px 0" :gutter="15">
                    <el-col :span="4">
                        <el-button
                                size="mini"
                                :disabled="!canModify"
                                @click="addInStoreRecordClick"
                                icon="el-icon-circle-plus"
                                type="primary">
                            新增入库批次
                        </el-button>

                    </el-col>

                    <el-col :span="3">
                        <el-button
                                :disabled="!canModify"
                                size="mini"
                                :loading="finishInStoreRecordLoading"
                                icon="el-icon-finished"
                                @click="finishInStore"
                                type="primary">
                            完结入库
                        </el-button>
                    </el-col>

                </el-row>
            </template>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="modifyDialogShow=false">关 闭</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
    /*
    入库控制台

    仓库入库管理
     */

    import OrderTable from "../components/orders/OrderTable"
    import OrderSearch from "../components/orders/OrderSearch"
    import NextFoo from "../components/NextFoo"

    import {mapGetters, mapMutations} from 'vuex'

    export default {
        name: "OrderInStore",
        data() {
            const orderUrl = this.$const.orderListUrl
            return {
                InStoreRecordListUrl: '/order_platform/api/in_store_records/',
                defaultUrl: `${orderUrl}?instorage__finish=false&ordering=id`,
                searchUrl: `${orderUrl}?instorage_not_exist=false`,
                count: 0,
                nextUrl: '',
                loading: false,
                modifyDialogShow: false,
                addInStoreRecordDialog: false,
                addInStoreRecordData: {},
                updateCurInStoreRecordLoading: false,
                deleteCurInStoreRecordLoading: false,
                finishInStoreRecordLoading: false,


                inStoreRecordDialog: false,
                currentInStoreRecord: {  // 默认值
                    sizeinstore_set: []
                },
                currentInStoreRecordId: '',
                createInStoreRecordLoading: false,


                orderTableItems: [
                    'orderStatus', 'urgent', 'produceInfoStatus', 'currentCraft',
                    'produceEstimate', 'planDate', 'finishInStorage', 'planInStorage'
                ],

                rules: {},

                // 快捷标签的配置数据
                countTagData: {
                    countTagsUrl: `${this.$const.orderListUrl}in_storage_counts/`,
                    dataArr: [
                        {
                            count: 0,
                            tagName: '已完成: ',
                            loading: false,
                            url: `${orderUrl}?instorage__finish=true`,
                            countKey: 'finished',
                            type: 'success',
                        },
                        {
                            count: 0,
                            tagName: '未完成: ',
                            loading: false,
                            url: `${orderUrl}?instorage__finish=false`,
                            countKey: 'un_finish',
                            type: 'danger',
                        },
                        {
                            count: 0,
                            tagName: '加急: ',
                            loading: false,
                            url: `${orderUrl}?instorage__finish=false&urgent=true`,
                            countKey: 'urgent',
                            type: 'danger',
                        },
                        {
                            count: 0,
                            tagName: '草稿: ',
                            loading: false,
                            url: `${orderUrl}?instorage__finish=false&instorage__current=DRAFT`,
                            countKey: 'draft',
                            type: 'danger',
                        },
                         {
                            count: 0,
                            tagName: '待入库: ',
                            loading: false,
                            url: `${orderUrl}?instorage__finish=false&instorage__current=WAIT`,
                            countKey: 'wait_in_storage',
                            type: 'danger',
                        },
                         {
                            count: 0,
                            tagName: '入库中: ',
                            loading: false,
                            url:`${orderUrl}?instorage__finish=false&instorage__current=HANDLE`,
                            countKey: 'handling',
                            type: 'danger',
                        },
                    ],
                },
            }
        },
        computed: {
            // 是否可以修改
            canModify() {
                return this.currentOrder.instorage ? !this.currentOrder.instorage.finish : false
            },
            finishInStoreUrl() {
                return `${this.$const.orderListUrl}/${this.currentOrder.id}/in_storage/`
            },
            inStoreRecords() {
                return this.currentOrder.instorerecord_set || []
            },
            addInStoreSum() {
                let sum = 0
                this.addInStoreRecordData.sizeinstore_set.forEach(sizeInStore => {
                    sum += sizeInStore.num
                })
                return sum
            },
            noMore() {
                return !Boolean(this.nextUrl)
            },
            ordersLength() {
                return this.orders.length
            },
            orders() {
                return this.inStoreOrderData['orderList']
            },
            currentOrder() {
                return this.currentInStoreOrderData['currentInStoreOrder']
            },
            ...mapGetters([
                'inStoreOrderData', 'currentInStoreOrderData'
            ])
        },
        methods: {
            updateCurrentInStoreRecord() {
                this.updateCurInStoreRecordLoading = true
                this.$patchRequest(this._getCurrentInStoreUrl(), this.currentInStoreRecord)
                    .then(response => {
                        this.updateCurInStoreRecordLoading = false
                        this.updateCurrentInStoreOrder(response.data)
                    })
                    .catch(error => {
                        this.updateCurInStoreRecordLoading = false
                    })

            },

            deleteCurrentInStoreRecord() {
                this.deleteCurInStoreRecordLoading = true
                this.$deleteRequest(this._getCurrentInStoreUrl())
                    .then(response => {
                        this.deleteCurInStoreRecordLoading = false
                        this.updateCurrentInStoreOrder(response.data)
                        this.inStoreRecordDialog = false
                        this.successMes(`成功删除${this.currentInStoreRecord.title}`)
                    })
                    .catch(response => {
                        this.deleteCurInStoreRecordLoading = false
                    })
            },

            _getCurrentInStoreUrl() {
                return `${this.InStoreRecordListUrl}/${this.currentInStoreRecordId}/`
            },
            showCurrentInStoreRecord(inStoreRecord, index) {
                this.inStoreRecordDialog = true
                this.initCurrentInStoreRecord(inStoreRecord, index)
            },
            initCurrentInStoreRecord(inStoreRecord, index) {
                const sizeinstore_set = []
                const orderSizeMap = new Map()
                this.currentOrder.ordersize_set.forEach(orderSize => {
                    orderSizeMap.set(orderSize.id, orderSize)
                })
                inStoreRecord.sizeinstore_set.forEach(sizeInStore => {
                    sizeinstore_set.push({
                        id: sizeInStore.id,
                        num: sizeInStore.num,

                        _maxNum: orderSizeMap.get(sizeInStore.order_size).in_storage_amount,  // 通知数量
                        // 仅展示用，不作为更新的数据
                        _shop_id: orderSizeMap.get(sizeInStore.order_size).size.shop_id      // 尺码
                    })
                })
                this.currentInStoreRecord = {
                    title: `入库批次${index}`,
                    sizeinstore_set,
                }
                this.currentInStoreRecordId = inStoreRecord.id
            },
            getSizeInStoreNum(sizeInStores, inStoreRecord) {
                for (let i = 0; i < sizeInStores.length; i++) {
                    const sizeInStore = sizeInStores[i]
                    if (sizeInStore.in_store_record.id === inStoreRecord.id) {
                        return sizeInStore.num
                    }
                }
            },

            // 完结入库
            finishInStore() {
                if (!this.checkFinishInStore()) {
                    return
                }
                this.finishInStoreRecordLoading = true
                const data = {
                    instorage: {
                        current: 'FINISH'
                    },
                }
                this.$postRequest(this.finishInStoreUrl, data)
                    .then(response => {
                        this.finishInStoreRecordLoading = false
                        this.updateCurrentInStoreOrder(response.data)
                        this.successMes('成功完结入库单！')

                    })
                    .catch(error => {
                        this.finishInStoreRecordLoading = false
                    })

            },
            checkFinishInStore() {
                if (this.currentOrder.finish_in_storage === this.currentOrder.in_storage_amount) {
                    return true
                } else {
                    this.$message.error(`入库通知数量 与 已入库数量不符合，无法完成!`)
                    return false
                }

            },
            createInStoreRecord() {
                if (!this.checkCreateInStore()) {
                    return
                }
                this.createInStoreRecordLoading = true
                this.$postRequest(this.InStoreRecordListUrl, this.addInStoreRecordData)
                    .then(response => {
                        this.updateCurrentInStoreOrder(response.data)
                        this.successMes('创建批次入库成功')
                        this.createInStoreRecordLoading = false
                        this.initAddInStoreRecordData()
                    })
                    .catch(error => {
                        this.createInStoreRecordLoading = false
                    })
            },
            checkCreateInStore() {
                if (this.currentOrder.in_storage_amount - this.currentOrder.finish_in_storage <= 0) {
                    this.$message({
                        type: 'error',
                        message: '剩余入库通知数量数量为 0，无法创建入库批次',
                        showClose: true,
                    })
                    return false
                }
                return true
            },


            addInStoreRecordClick() {
                if (!this.checkCreateInStore()) {
                    return
                }
                this.addInStoreRecordDialog = true
                this.initAddInStoreRecordData()
            },
            inStoreSummaries({columns, data}) {
                const sums = this._defaultSummaries({columns, data})
                const inStoreRecordSum = []

                for (let i = 0; i < this.inStoreRecords.length; i++) {
                    sums.pop()

                    inStoreRecordSum.push(this.inStoreRecords[i].num)
                }
                sums.push(...inStoreRecordSum)
                return sums

            },

            addInStoreSummaries({columns, data}) {
                const sums = this._defaultSummaries({columns, data})
                sums[columns.length - 1] = this.addInStoreSum
                return sums
            },

            _defaultSummaries({columns, data}) {
                return this.$defaultTableSummary({columns, data})
            },
            initAddInStoreRecordData() {
                const sizeinstore_set = []
                this.currentOrder.ordersize_set.forEach((orderSize) => {
                    sizeinstore_set.push({
                        shop_id: orderSize.size.shop_id,
                        color: orderSize.color,
                        planNum: orderSize.in_storage_amount,
                        FinishNum: orderSize.finish_in_storage,
                        order_size: orderSize.id,
                        num: orderSize.in_storage_amount - orderSize.finish_in_storage,
                        maxNum: orderSize.in_storage_amount - orderSize.finish_in_storage,
                    })
                })
                this.addInStoreRecordData = {
                    platform_order: this.currentOrder.id,
                    sizeinstore_set,
                }
            },
            handleNext(response) {
                this.addOrderRes(response)
                this.successMes(`加载了 ${response.data.results.length} 个订单`)
            },
            clickModify(order) {
                this.modifyDialogShow = true
                this.updateCurrentInStoreOrder(order)
            },
            handleClose(close) {
                close()
            },
            initOrders() {
                if (this.ordersLength <= 0) {
                    this.loading = true
                    this.$getRequest(this.defaultUrl)
                        .then(response => {
                            this.loading = false
                            this.initOrderRes(response)
                        })
                        .catch(error => {
                            this.loading = false
                        })
                }
            },
            addOrderRes(response) {
                const handler = this.addInStoreOrders
                this._handleOrderRes(response, handler)
            },

            initOrderRes(response) {
                const handler = this.initInStoreOrders
                this._handleOrderRes(response, handler)
            },

            _handleOrderRes(response, handler) {
                this.nextUrl = this.$utils.handleOrderUrl(response.data.next)
                this.count = response.data.count
                const orders = response.data.results
                handler(orders)
            },
            successMes(message) {
                this.$message({
                    type: 'success',
                    showClose: true,
                    message: message
                })
            },
            ...mapMutations([
                'initInStoreOrders', 'addInStoreOrders', 'updateCurrentInStoreOrder'
            ])


        },
        components: {NextFoo, OrderSearch, OrderTable},
        updated() {
            this.$refs.inStoreOrder.setCurrentRow(this.currentOrder)
        },
        created() {
            this.initOrders()
        }
    }
</script>

<style scoped>

</style>